import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Grid } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import dlv from 'dlv';
import { isArray } from 'lodash';
import React from 'react';
import { ExposureConfigurationResponse } from '../../../api/ConfigApi';
import { AuthData, HIDE_PERIL_LIMITS_ENABLE } from '../../../context/auth';
import { CurrencyCode } from '../../../types/currencyCode';
import {
	PerilCreateRequest,
	PolicyCharacteristics,
} from '../../../types/policy';
import LimitsForm from '../Perils/LimitsForm';
import ReviewChangesField from './ReviewChangesField';

interface Props {
	addedPerils: PerilCreateRequest[];
	exposureConfiguration: ExposureConfigurationResponse;
	policyCharacteristic: PolicyCharacteristics;
	currency: CurrencyCode;
	authData: AuthData;
}

const AddedPerils = (props: Props) => {
	const { addedPerils, exposureConfiguration, currency, authData } = props;
	const hidePerilLimitsEnabled =
		authData?.auth?.configProperties?.[HIDE_PERIL_LIMITS_ENABLE] ?? false;

	if (!addedPerils.length) {
		return null;
	}

	const renderFields = (addedPeril: PerilCreateRequest) => {
		const perilConfig = exposureConfiguration.perils.find(
			(config) => config.name === addedPeril.name,
		);
		const fieldConfigs = perilConfig.fields;
		return fieldConfigs.map((field, ind) => {
			let value = dlv(addedPeril, `fieldValues.${field.name}`, '--');
			if (isArray(value)) {
				value = value[0];
			}
			return (
				<Grid item key={`${field}-${ind}`}>
					<ReviewChangesField
						key={`${field}-${ind}`}
						field={field}
						value={value}
						fieldGroupsByLocator={null}
						allValues={addedPeril.fieldValues}
						currentFieldValues={addedPeril.fieldValues}
						addFieldGroups={addedPeril.fieldGroups}
					/>
				</Grid>
			);
		});
	};

	const renderLimits = (addedPeril: PerilCreateRequest) => {
		return (
			<LimitsForm
				perilObj={addedPeril}
				id={`${addedPeril.name}-${Math.random()}`}
				perilConfig={addedPeril}
				currency={currency}
				isInEditMode={false}
				userHasWriteAccess={false}
				updateLimit={null}
			/>
		);
	};

	const renderAddedExposureAccordions = () => {
		return addedPerils.map((addedPeril, ind) => {
			const perilConfig = exposureConfiguration.perils.find(
				(config) => config.name === addedPeril.name,
			);
			const displayName = perilConfig.displayName;
			return (
				<Accordion key={`addedPeril-${ind}`}>
					<AccordionSummary
						style={{ borderBottom: '1px solid rgba(0, 0, 0, .125)' }}
						expandIcon={<ExpandMoreIcon />}
					>{`Added: ${displayName}`}</AccordionSummary>
					<AccordionDetails
						style={{ display: 'flex', flexDirection: 'column' }}
					>
						<Grid container spacing={1}>
							{renderFields(addedPeril)}
						</Grid>
						{!hidePerilLimitsEnabled && renderLimits(addedPeril)}
					</AccordionDetails>
				</Accordion>
			);
		});
	};

	return <>{renderAddedExposureAccordions()}</>;
};

export default AddedPerils;
